var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vida-navbar',{attrs:{"active":"about"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-primary"},[_c('div',[_c('h1',{staticClass:"title"},[_vm._v("404 Error")]),_c('p',{staticClass:"subtitle"},[_vm._v("Ooops this page doesn't exist.")])])])
}]

export { render, staticRenderFns }